module.exports = __webpack_public_path__ + "static/media/Git Icon.08ec5722.png";